export interface NotificationMessage {
  submitSuccess: string;
  saveSuccess: string;
  approveSuccess: string;
  saveFail: string;
  submissionFailed: string;
  somethingWentWrong: string;
}

export const NOTIFICATION_MESSAGES: NotificationMessage = {
  submitSuccess: 'Submitted Successfully',
  saveSuccess: 'Saved Successfully',
  approveSuccess: 'Approved Successfully',
  saveFail: 'Save Failed',
  submissionFailed: 'Submission Failed',
  somethingWentWrong: 'Something went wrong..',
};

export interface DialogMessages {
  confirmTitle: string;
  areYouSureMessage: string;
  deleteDocumentMessage: string;
  cancelDocumentMessage: string;
  withdrawlContent: string;
  submitConsentContent: string;
  confirmYes: string;
  confirmNo: string;
  confirm: string;
  confirmAndContinue: string;
  pleaseConfirmActionCannotBeUndone: string;
  actionWillCancelReferralPleaseConfirm: string;
  save: string;
  doYouWishToSubmit: string;
}

export const DIALOG_MESSAGES: DialogMessages = {
  confirmTitle: 'Please confirm',
  areYouSureMessage: 'Are you sure?',
  deleteDocumentMessage: 'Are you sure you want to delete the document?',
  cancelDocumentMessage: 'Are you sure you want to cancel?',
  withdrawlContent:
    'I am in agreement with the recommendations made at this meeting for alternatives to special education.  I understand that the initial referral will be withdrawn.',
  submitConsentContent:
    'Parent/Principal Written Agreement to Withdraw an Initial Referral Successful.',
  confirmYes: 'Yes',
  confirmNo: 'No',
  confirm: 'Confirm',
  confirmAndContinue: 'Confirm and Continue',
  pleaseConfirmActionCannotBeUndone:
    'Please confirm you\'re ready to submit this form. This action cannot be undone.',
  actionWillCancelReferralPleaseConfirm:
    'This action will cancel the referral - all data will be lost. Are you sure you want to continue?',
  save: 'Save',
  doYouWishToSubmit: 'Do you wish to submit?',
};

export const OUTSTANDING_ASSESSMENTS_TEXT: string =
  'You have outstanding assessments. Please either get them finalized and reconvene the IEP meeting or remove them if they are no longer necessary and proceed to create a ';

export const MANDATED_THREE_YEAR_REEVALUATION_TEXT: string =
  ' Mandated Three-Year reevaluation';

export const NEW_ADDITIONAL_REEVALUATION_TEXT: string =
  ' new additioal reevaluation';

export const NEW_REEVALUATION: string = ' new reevaluation';

export const DATE_OF_BIRTH_MISSING: string =
  'Date of Birth missing on Student record';
